var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, object-curly-spacing, react/jsx-closing-bracket-location, react/jsx-indent-props, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

// TODO(joel): teach KAS how to accept an answer only if it's expressed in
// terms of a certain type.
// TODO(joel): Allow sigfigs within a range rather than an exact expected
// value?

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var InlineIcon = require("../components/inline-icon.jsx");
var NumberInput = require("../components/number-input.jsx");

var _require = require("../icon-paths.js"),
    iconOk = _require.iconOk,
    iconRemove = _require.iconRemove;

var _require2 = require("../sigfigs.jsx"),
    displaySigFigs = _require2.displaySigFigs;

var ALL = "all";
var SOME = "some";
var MAX_SIGFIGS = 10;

var sigfigPrint = function sigfigPrint(num, sigfigs) {
    return displaySigFigs(num, sigfigs, -MAX_SIGFIGS, false);
};

// Extract the primitive units from a unit expression. This first simplifies
// `expr` to a `Mul` like "5 kg m / s^2" then removes the first term.
var primUnits = function primUnits(expr) {
    return expr.simplify().asMul().partition()[1].flatten().simplify();
};

// Show the name of a unit and whether it's recognized by KAS.
//
// In the future I plan for this to show an example of a thing that would be
// accepted in that unit.
var UnitExample = React.createClass({
    displayName: "UnitExample",

    render: function render() {
        var icon;
        if (this.state.valid) {
            icon = React.createElement(
                "span",
                null,
                React.createElement(
                    "span",
                    { className: "unit-example-okay" },
                    React.createElement(InlineIcon, iconOk)
                ),
                this.state.solvedExample
            );
        } else {
            icon = React.createElement(
                "span",
                { className: "unit-example-not-okay" },
                React.createElement(InlineIcon, iconRemove)
            );
        }

        return React.createElement(
            "div",
            null,
            icon,
            " ",
            this.props.name
        );
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this._checkValidity(nextProps);
    },

    componentWillMount: function componentWillMount() {
        this._checkValidity(this.props);
    },

    _checkValidity: function _checkValidity(_ref) {
        var name = _ref.name,
            original = _ref.original,
            sigfigs = _ref.sigfigs;

        var parseResult = KAS.unitParse(name);
        var solvedExample = "";

        // A unit is valid if it parses and is equivalent to the original.
        var valid = true;

        if (parseResult.parsed && original) {
            var x = new KAS.Var("x");
            var unit = parseResult.unit;

            var equality = new KAS.Eq(original, "=", new KAS.Mul(x, unit));
            try {
                var answer = equality.solveLinearEquationForVariable(x);

                // The third parameter is the least significant decimal place.
                // I.e. the index of the last place you care about
                // (543210.(-1)(-2)(-3) etc). We use -10 because that should
                // always be safe since we only care up to maximum 10 decimal
                // places.
                solvedExample = sigfigPrint(answer.eval(), sigfigs);

                valid = KAS.compare(primUnits(original), primUnits(unit)).equal;
            } catch (e) {
                valid = false;
            }
        } else {
            valid = false;
        }

        this.setState({
            valid: valid,
            solvedExample: solvedExample
        });
    }
});

var UnitInputEditor = React.createClass({
    displayName: "UnitInputEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        value: React.PropTypes.string,
        acceptingUnits: React.PropTypes.arrayOf(React.PropTypes.string),
        accepting: React.PropTypes.oneOf([ALL, SOME]),
        sigfigs: React.PropTypes.number
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            value: "5x10^5 kg m / s^2",
            accepting: ALL,
            sigfigs: 3
        };
    },

    render: function render() {
        var _this = this;

        var _props = this.props,
            acceptingUnits = _props.acceptingUnits,
            accepting = _props.accepting;

        acceptingUnits = acceptingUnits || [];
        var acceptingElem = null;
        if (accepting === SOME) {
            var unitsArr = acceptingUnits.map(function (name, i) {
                return React.createElement(UnitExample, {
                    name: name,
                    original: _this.original || null,
                    sigfigs: _this.props.sigfigs,
                    key: i
                });
            });

            acceptingElem = React.createElement(
                "div",
                null,
                React.createElement("input", {
                    type: "text",
                    defaultValue: acceptingUnits.join(", "),
                    onChange: this.handleAcceptingUnitsChange
                }),
                " ",
                "(comma-separated)",
                unitsArr
            );
        }

        return React.createElement(
            "div",
            { className: "unit-editor" },
            React.createElement(
                "div",
                null,
                React.createElement("input", {
                    value: this.props.value,
                    className: "unit-editor-canonical",
                    onBlur: this._handleBlur,
                    onKeyPress: this._handleBlur,
                    onChange: this.onChange
                }),
                " ",
                this.parsed ? React.createElement(
                    "span",
                    { className: "unit-example-okay" },
                    React.createElement(InlineIcon, iconOk)
                ) : React.createElement(
                    "span",
                    { className: "unit-example-not-okay" },
                    React.createElement(InlineIcon, iconRemove)
                )
            ),
            React.createElement(
                "div",
                null,
                "Significant Figures:",
                " ",
                React.createElement(NumberInput, {
                    value: this.props.sigfigs,
                    onChange: this.handleSigfigChange,
                    checkValidity: this._checkSigfigValidity,
                    useArrowKeys: true
                })
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    React.createElement("input", {
                        type: "radio",
                        name: this.groupId,
                        onChange: function onChange() {
                            return _this._setAccepting(ALL);
                        },
                        checked: this.props.accepting === ALL
                    }),
                    " Any equivalent unit "
                ),
                React.createElement(
                    "label",
                    null,
                    React.createElement("input", {
                        type: "radio",
                        name: this.groupId,
                        onChange: function onChange() {
                            return _this._setAccepting(SOME);
                        },
                        checked: this.props.accepting === SOME
                    }),
                    " Only these units "
                )
            ),
            acceptingElem
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    handleAcceptingUnitsChange: function handleAcceptingUnitsChange(event) {
        var acceptingUnits = event.target.value.split(",").map(function (str) {
            return str.trim();
        }).filter(function (str) {
            return str !== "";
        });
        this.change({ acceptingUnits: acceptingUnits });
    },

    handleSigfigChange: function handleSigfigChange(sigfigs) {
        this.change({ sigfigs: sigfigs });
    },

    _checkSigfigValidity: function _checkSigfigValidity(sigfigs) {
        return sigfigs > 0 && sigfigs <= MAX_SIGFIGS;
    },

    _setAccepting: function _setAccepting(val) {
        this.change({ accepting: val });
    },

    componentWillMount: function componentWillMount() {
        this.groupId = _.uniqueId("accepting");
        this._doOriginal(this.props);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this._doOriginal(nextProps);
    },

    _doOriginal: function _doOriginal(props) {
        var tryParse = KAS.unitParse(props.value);
        this.parsed = false;

        // Only update this state if the unit parsed *and* it has a magnitude
        // attached to it. KAS can also parse units without magnitudes ("1.2
        // g" vs "g").
        if (tryParse.parsed && tryParse.type === "unitMagnitude") {
            this.original = tryParse.expr;
            this.parsed = true;
        }
    },

    onChange: function onChange(event) {
        this.props.onChange({ value: event.target.value });
    },

    getSaveWarnings: function getSaveWarnings() {
        var _props2 = this.props,
            value = _props2.value,
            accepting = _props2.accepting,
            acceptingUnits = _props2.acceptingUnits;

        var warnings = [];

        var tryParse = KAS.unitParse(value);
        if (!tryParse.parsed) {
            warnings.push("Answer did not parse");
        }

        if (accepting === SOME && acceptingUnits.length === 0) {
            warnings.push("There are no accepted units");
        }

        return warnings;
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = UnitInputEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/unit-editor.jsx
 ** module id = 155
 ** module chunks = 0 1
 **/